import { TableCell, TableRow, Typography } from '@mui/material';
import DataTable from '@/components/DataTable/DataTable';
import { formatTimestamp } from '@/utils/date/date';
import FileImportCountSummary from './FileImportCountSummary';
import FileImportStatusChip from './FileImportStatusChip';
import { formatFileImportLabel } from './fileImportFormatters';

const importColumns = [
  { key: 'source_file_name', label: 'File Name', sortable: true },
  {
    key: 'import_type',
    label: 'Import Type',
    render: (value) => formatFileImportLabel(value),
  },
  {
    key: 'status',
    label: 'Import Status',
    render: (value) => <FileImportStatusChip value={value} />,
  },
  {
    key: 'notification_status',
    label: 'Notification',
    render: (value) => <FileImportStatusChip value={value} />,
  },
  {
    key: 'sftp_move_status',
    label: 'SFTP Move',
    render: (value) => <FileImportStatusChip value={value} />,
  },
  { key: 'row_count', label: 'Rows' },
  { key: 'seen_count', label: 'Seen' },
  {
    key: 'row_status_counts',
    label: 'Row Status Counts',
    render: (value) => <FileImportCountSummary counts={value} />,
  },
  {
    key: 'row_action_counts',
    label: 'Action Counts',
    render: (value) => <FileImportCountSummary counts={value} />,
  },
  {
    key: 'created_at',
    label: 'Imported At',
    sortable: true,
    render: (value) => formatTimestamp(value),
  },
];

const SftpConnectionImportsTable = ({
  organizationId,
  connectionId,
  onRowClick,
}) => (
  <DataTable
    columns={importColumns}
    endpoint={`/organizations/${organizationId}/sftp-connections/${connectionId}/imports`}
    initialSort={{ key: 'created_at', order: 'desc' }}
    pageSize={25}
    autoFetch={true}
    enableColumnPicker={true}
    enableSorting={true}
    onRowClick={onRowClick}
    renderEmptyState={() => (
      <TableRow>
        <TableCell colSpan={importColumns.length} align='center' sx={{ py: 8 }}>
          <Typography variant='body1' color='text.secondary'>
            No import reports found for this SFTP connection.
          </Typography>
        </TableCell>
      </TableRow>
    )}
  />
);

export default SftpConnectionImportsTable;
